import { createSelector } from "reselect";

// Utils
import { buildQueryString } from "src/utils/build_query_string";

// Selectors
import { createWoundTalliesPayloadSelector } from "../create_wound_tallies_payload_selector";

/**
 * Create a selector to get all contexts for location tallies
 * @returns {Function} selector
 */
export function createWoundTalliesContextSelector() {
  return createSelector(
    createWoundTalliesPayloadSelector(),
    payload => {
      if (!payload) return payload;
      return buildQueryString(payload);
    }
  );
}
